var Notification = {
    init: function () {
        var self = this;

        jQuery('nav .main-bell .nav-link').click(function (e) {
            e.preventDefault();

            self.show();
        });

        jQuery('#notifications-holder .btn-close').click(function () {
            self.hide();
        });

        jQuery('.main-content #content').click(function () {
            if (self.isOpened()) {
                self.hide();
            }
        });
    },

    show: function () {
        jQuery('#notifications-holder').show();
        jQuery('nav .main-bell .nav-link .number').hide();

        jQuery.cookie('_notification_shown', true);

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
            var aloomaData = jQuery.extend({}, aloomaPageData);
            aloomaData.pop_name = 'New! Special offers';

            aloomaSendEvent('notification_opened', aloomaData);
        }
    },

    hide: function () {
        jQuery('#notifications-holder').hide();

        if (typeof aloomaPageData !== 'undefined' && typeof aloomaSendEvent !== 'undefined') {
            var aloomaData = jQuery.extend({}, aloomaPageData);
            aloomaData.pop_name = 'New! Special offers';

            aloomaSendEvent('notification_closed', aloomaData);
        }
    },

    isOpened: function () {
        return jQuery('#notifications-holder').css('display') !== 'none';
    }
};

Notification.init();